export default __webpack_public_path__ + "static/media/mobile-hero-image.e5318b0e.jpg";